module.exports = __WEBPACK_EXTERNAL_MODULE_160__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 160
// module chunks = 0